import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PartnersModule } from '@app/modules/partners/partners.module';
import { ReviewCarouselComponent } from '@app/modules/signup-new/components/review-carousel/review-carousel.component';
import { SignupQuickFactsComponent } from '@app/modules/signup-new/components/signup-quick-facts/signup-quick-facts.component';
import { SignupRootComponent } from '@app/modules/signup-new/components/signup-root/signup-root.component';
import { SignupUserHeaderComponent } from '@app/modules/signup-new/components/signup-user-header/signup-user-header.component';
import { SignupWelcomeComponent } from '@app/modules/signup-new/components/signup-welcome/signup-welcome.component';
import { SignupWizardTemplateComponent } from '@app/modules/signup-new/components/signup-wizard-template/signup-wizard-template.component';
import { SignupWizardComponent } from '@app/modules/signup-new/components/signup-wizard/signup-wizard.component';
import { SignupChannelsPageComponent } from '@app/modules/signup-new/pages/signup-channels-page/signup-channels-page.component';
import { SignupDonePageComponent } from '@app/modules/signup-new/pages/signup-done-page/signup-done-page.component';
import { SignupEmailPageComponent } from '@app/modules/signup-new/pages/signup-email-page/signup-email-page.component';
import { SignupMobilePageComponent } from '@app/modules/signup-new/pages/signup-mobile-page/signup-mobile-page.component';
import { SignupNamePageComponent } from '@app/modules/signup-new/pages/signup-name-page/signup-name-page.component';
import { SignupOnboardingPageComponent } from '@app/modules/signup-new/pages/signup-onboarding-page/signup-onboarding-page.component';
import { SignupPasswordPageComponent } from '@app/modules/signup-new/pages/signup-password-page/signup-password-page.component';
import { SignupPropertiesPageComponent } from '@app/modules/signup-new/pages/signup-properties-page/signup-properties-page.component';
import { SignupRestrictedPageComponent } from '@app/modules/signup-new/pages/signup-restricted-page/signup-restricted-page.component';
import { SignupReturningPageComponent } from '@app/modules/signup-new/pages/signup-returning-page/signup-returning-page.component';
import { SignupValidateMobilePageComponent } from '@app/modules/signup-new/pages/signup-validate-mobile-page/signup-validate-mobile-page.component';
import { SignupWithAirbnbCallbackComponent } from '@app/modules/signup-new/pages/signup-with-airbnb-callback/signup-with-airbnb-callback.component';
import { SignupWithAirbnbPageComponent } from '@app/modules/signup-new/pages/signup-with-airbnb-page/signup-with-airbnb-page.component';
import { SignupRoutingModule } from '@app/modules/signup-new/signup-routing.module';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [CommonModule, SignupRoutingModule, SharedModule, CdkStepperModule, PartnersModule],
  exports: [],
  declarations: [
    SignupRootComponent,
    SignupEmailPageComponent,
    SignupNamePageComponent,
    SignupMobilePageComponent,
    ReviewCarouselComponent,
    SignupQuickFactsComponent,
    SignupChannelsPageComponent,
    SignupPasswordPageComponent,
    SignupOnboardingPageComponent,
    SignupValidateMobilePageComponent,
    SignupPropertiesPageComponent,
    SignupDonePageComponent,
    SignupWizardComponent,
    SignupWizardTemplateComponent,
    SignupReturningPageComponent,
    SignupRestrictedPageComponent,
    SignupWelcomeComponent,
    SignupUserHeaderComponent,
    SignupWithAirbnbPageComponent,
    SignupWithAirbnbCallbackComponent,
  ],
  providers: [],
})
export class SignupModule {}
